import { useContext } from 'react';
import { faInfoCircle, faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, Button } from '@mui/material';

import { AnimatedTransition } from '../../../../components/animated-transition';
import { PortfolioPerformanceContext } from '../../../../providers/portfolio-performance';
import { CheckLastUpdatePortfolioPerformance } from '../check-last-update';
import './styles.scss';

export const PortfolioPerformanceHeader = () => {
  const { isNamesBlurred, setIsNamesBlurred } = useContext(PortfolioPerformanceContext);

  return (
    <div className="portfolio-performance-header">
      <AnimatedTransition className="fade">
        <div className="portfolio-performance-header-accounts-aggregated">
          <h2>Portfolio Performance</h2>
          <div className="portfolio-performance-header-accounts-aggregated-tooltip-area">
            <Tooltip title={''}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </Tooltip>
          </div>
          <div className="portfolio-performance-header-last-update">
            <CheckLastUpdatePortfolioPerformance lastUpdate={new Date().toISOString()} />
          </div>
          <Tooltip title={isNamesBlurred ? 'Show account names' : 'Blur account names for demo'}>
            <Button
              className="portfolio-performance-header-blur-toggle"
              aria-label={isNamesBlurred ? 'Show account names' : 'Blur account names for demo'}
              onClick={() => setIsNamesBlurred((prev) => !prev)}
            >
              <FontAwesomeIcon icon={isNamesBlurred ? faEyeSlash : faEye} />
            </Button>
          </Tooltip>
        </div>
      </AnimatedTransition>
    </div>
  );
};
